import api from '../common/api'

export default {
  user_profile ({ commit, state }, data) {
    api.users
      .profile()
      .then(data => {
        commit('user_profile', data)
      })
      .catch(err => {
        console.log(err)
      })
  }
}
